import React from "react";
import { useState, useEffect } from "react";
import { HistoryIcon } from "lucide-react";
import { useMatch } from "react-router-dom";

const ApplicationHistory = ({
  currentApplicationId,
  previousApplications,
  onShowHistory,
}) => {
  if (!previousApplications) return null;
  const PreScreenUrl = useMatch("/vacancies/:vacancyId/pre-screen");

  // write a function get latest status from an array based on created_at date..
  const getLatestStatus = (statusHistory) => {
    if (!Array.isArray(statusHistory) || statusHistory.length === 0)
      return null;
    const latestStatus = statusHistory.sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at),
    )[0];
    return latestStatus?.vacancy_status?.status || null;
  };

  return (
    <>
      <div className="bg-card rounded-lg border border-border p-4">
        <h3 className="text-lg font-semibold text-foreground flex items-center gap-2 mb-3">
          <HistoryIcon className="w-5 h-5" />
          Applications
        </h3>
        <div className="flex flex-col gap-y-3">
          {previousApplications?.length > 0 &&
            previousApplications?.map((previousApplication, index) => (
              <div
                key={index}
                className={`flex items-center flex-col gap-y-2 bg-muted p-3 rounded-lg ${previousApplication.id == currentApplicationId ? `border-green-400 border-2 order-1` : `order-2`} ${PreScreenUrl ? "" : "cursor-pointer"}`}
                onClick={() => {
                  if (
                    !PreScreenUrl &&
                    previousApplication.id !== currentApplicationId
                  ) {
                    window.open(
                      `/vacancies/${previousApplication.vacancy_id}/applications/${previousApplication.id}`,
                      "_blank",
                    );
                  }
                }}
              >
                <div className="w-full">
                  <span className="text-foreground font-medium">
                    {previousApplication?.vacancy?.title}
                  </span>
                  {getLatestStatus(
                    previousApplication.application_status_history,
                  ) && (
                    <span className="text-xs text-foreground ml-4 bg-muted rounded-full px-2 py-1">
                      {
                        getLatestStatus(
                          previousApplication.application_status_history,
                        ).name
                      }
                    </span>
                  )}
                  {/* <span className="text-sm text-foreground">{previousApplication?.vacancy}</span> */}
                </div>
                <div className="w-full flex justify-between items-center">
                  <div className="flex flex-col">
                    <span className=" text-slate-400">
                      {previousApplication?.vacancy?.campaign?.company?.name}
                    </span>
                    <span className="text-sm text-slate-400">
                      {previousApplication?.created_at?.substring(
                        0,
                        previousApplication?.created_at?.lastIndexOf(":"),
                      )}
                    </span>
                  </div>

                  {previousApplication?.application_status_history?.length >
                    0 &&
                    previousApplication.id !== currentApplicationId && (
                      <button
                        className="px-2 py-1 mt-[19px] text-xs bg-muted text-muted-foreground rounded hover:bg-muted"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          onShowHistory(previousApplication);
                        }}
                      >
                        History
                      </button>
                    )}
                </div>
              </div>
            ))}
          {!previousApplications && (
            <div className="flex items-center justify-between bg-muted p-3 rounded-lg">
              <div className="flex flex-col">
                <span className="text-foreground font-medium">No Applications</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ApplicationHistory;
